<script>
    export let filterApplied
    export let url
    export let facets
    let q = ''

    function withQuery(urlString, q) {
        const url = new URL(urlString)
        const params = url.search.substr(1).split('&')
        const newParams = params.filter((param) => param.indexOf('q=') === -1)
        if (q) {
            newParams.push(`q=${encodeURIComponent(q)}`)
        }
        const newSearch = newParams.join('&')
        return urlString.replace(url.search, `?${newSearch}`)
    }

    async function searchFacet(link) {
        const newUrl = `${url}&${link}`
        const response = await fetch(newUrl)
        const json = await response.json()
        filterApplied(newUrl, json)
    }

    async function search() {
        const newUrl = withQuery(url, q)
        const response = await fetch(newUrl)
        const json = await response.json()
        filterApplied(newUrl, json)
    }
</script>

<div class="input-group" style="width:100%">
    <label for="filter-text" class="sr-only">Filter by text </label>
    <input
        bind:value={q}
        class="text-filter-field form-control"
        type="text"
        name="q"
        id="filter-text"
    />
    <div class="input-group-btn">
        <button
            on:click={search}
            class="btn btn-default"
            title="Filter by text"
            aria-label="Filter by text"
        >
            <span class="glyphicon glyphicon-search" />
        </button>
    </div>
</div>

<div class="well">
    <h3>
        Filter met <!--        <a class="btn btn-xs pull-right" href="#">Clear All </a>-->
    </h3>
    <!-- <ul> -->
    <!--     <li> -->
    <!--         <a href="/resources?include_components=true&amp;sort=title_sort+asc">Record Type: Archival Object -->
    <!--             <span class="glyphicon glyphicon-remove"></span> -->
    <!--         </a> -->
    <!--     </li> -->
    <!-- </ul> -->
    {#each facets as facet}
        <h3>{facet.Label}</h3>
        <ul>
            {#each facet.Links as link}
                <li on:click={() => searchFacet(link.Link)}>
                    <a href="#" on:click|preventDefault>{link.Label}</a>
                    <span class="badge">{link.Count}</span>
                </li>
            {/each}
        </ul>
    {/each}
</div>
